import type { Meta, StoryObj } from "@storybook/react";

import type { GroupRegistrationCardProps } from "@/ui/components/groupClasses/series/GroupRegistrationCard";
import GroupRegistrationCard from "@/ui/components/groupClasses/series/GroupRegistrationCard";
import { IllustrationName } from "@/ui/theme/icons/illustrations/groupClasses";

const StoryMeta: Meta<GroupRegistrationCardProps> = {
  title: "Components/Group Classes/Group Registration Card",
  component: GroupRegistrationCard,
  argTypes: {
    description: { control: "text" },
    durationInWeeks: { control: "number" },
    iconName: {
      control: "select",
      options: Object.values(IllustrationName),
    },
    title: { control: "text" },
  },
  args: {
    description:
      "Learn Dialectical Behavior Therapy (DBT) skills to manage strong emotions, stress, and urges so you can reduce eating disorder behaviors and stay on track with your treatment.",
    durationInWeeks: 16,
    iconName: IllustrationName.Applause,
    testID: "group-registration-card",
    title: "DBT Skills Group",
  },
};

type Story = StoryObj<GroupRegistrationCardProps>;

const Primary: Story = {};

const ShortDuration: Story = {
  args: {
    durationInWeeks: 8,
    title: "Intro Skills Group",
  },
};

const DifferentIcon: Story = {
  args: {
    iconName: IllustrationName.Lightbulb,
    title: "Mindfulness Group",
  },
};

const LongTitle: Story = {
  args: {
    title: "Caregivers of Young Adults (ages 18+): Support and Skills",
  },
};

export { DifferentIcon, LongTitle, Primary, ShortDuration };
export default StoryMeta;
